module.exports = __webpack_public_path__ + "img/icon_3_30.25377b93.png";